import EmptyLayout from "@/layout/EmptyLayer";

const BetaRouter = {
  path: "/content",
  name: "Content",
  redirect: "/content/projects-list",
  component: EmptyLayout,
  children: [
    {
      path: "projects-list",
      name: "ContentProjectsList",
      component: () => import("@/views/Content/ProjectsList.vue"), 
    },
    {
      path: "project-tasks",
      name: "ContentProjectTasks",
      component: () => import("@/views/Content/ProjectTasks.vue"), 
    },
  ],
};

export default BetaRouter;
